/** Monevo loan purpose for a credit card */
const CREDIT_CARD_LOAN_PURPOSE = 29;
const cardTypeOf = (enquiry) => {
    switch (enquiry.partner) {
        case 'BROADBANDCHOICES':
            return enquiry.type === 'BROADBAND' ? 'BROADBAND' : null;
        case 'MONEYSUPERMARKET':
            return enquiry.type === 'ENERGY' ? 'ENERGY' : null;
        case 'MONEVO_UK':
            if (enquiry.type === 'CREDIT_CARD')
                return 'CREDIT_CARD';
            if (enquiry.type === 'LOAN')
                return 'LOAN';
            return enquiry.metadata?.qs?.loan_purpose === CREDIT_CARD_LOAN_PURPOSE
                ? 'CREDIT_CARD'
                : 'LOAN';
        default:
            return null;
    }
};
const isDrawable = (enquiry, now) => {
    if (!enquiry.id || !enquiry.createdAt || enquiry.dismissedAt)
        return false;
    if (enquiry.partner === 'MONEVO_UK') {
        if (!enquiry.metadata?.url) {
            return false;
        }
    }
    else if (!enquiry.partnerId) {
        return false;
    }
    if (enquiry.expiresAt && new Date(enquiry.expiresAt).getTime() <= now) {
        return false;
    }
    return true;
};
const buildCards = (enquiries, now = Date.now()) => {
    const newest = new Map();
    enquiries.forEach((enquiry) => {
        if (!isDrawable(enquiry, now))
            return;
        const type = cardTypeOf(enquiry);
        if (!type)
            return;
        const card = {
            id: enquiry.id,
            partner: enquiry.partner,
            type,
            url: enquiry.metadata?.url ?? undefined,
            createdAt: enquiry.createdAt,
            expiresAt: enquiry.expiresAt ?? null,
        };
        const held = newest.get(type);
        if (!held || held.createdAt < card.createdAt)
            newest.set(type, card);
    });
    return [...newest.values()].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
};
export default buildCards;
